<template>
  <div class="od-container" id="location">
    <div class="contents">
      <h3>오늘하루치과 진료안내</h3>
      <div class="map" id="oneday-location">
        <!--        <naver-maps-->
        <!--          :height="height"-->
        <!--          :mapOptions="mapOptions"-->
        <!--          :initLayers="['BACKGROUND', 'BACKGROUND_DETAIL', 'BYCYCLE', 'CADASTRAL', 'CTT', 'HIKING_TRAIL', 'PANORAMA', 'POI_KOREAN', 'TRANSIT']"-->
        <!--          @load="onLoad">-->
        <!--          <naver-info-window-->
        <!--            class="info-window"-->
        <!--            @load="onWindowLoad"-->
        <!--            :isOpen="true"-->
        <!--            :marker="marker">-->
        <!--            <div class="info-window-container">-->
        <!--              <h1>{{'오늘하루 치과'}}</h1>-->
        <!--            </div>-->
        <!--          </naver-info-window>-->
        <!--          <naver-marker :lat="mapOptions.lat" :lng="mapOptions.lng" @click="onMarkerClicked" @load="onMarkerLoaded" />-->
        <!--        </naver-maps>-->
        <!--        <iframe-->
        <!--          :src="mapSrc"-->
        <!--          width="600" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>-->
      </div>

      <div class="location_info">
        <div class="time_info">
          <dl>
            <dt>진료안내</dt>
            <dd>
              <ul>
                <li>
                  <span class="tit">월요일-금요일</span>
                  <span class="time">10:00 - 18:30</span>
                </li>
                <li>
                  <span class="tit">토요일</span>
                  <span class="time">10:00 - 14:00</span>
                </li>
                <li>
                  <span class="tit">점심시간</span>
                  <span class="time">13:00 - 14:00</span>
                </li>
              </ul>
              <span class="t1">* 토요일은 점심시간 없이 진료합니다.</span>
              <span class="t2">일요일, 공휴일 휴진</span>
            </dd>
          </dl>
          <dl>
            <dt>야간진료</dt>
            <dd>
              <ul class="info">
                <li>
                  <span class="tit">화/목요일</span>
                  <span class="time">21:00 까지</span>
                </li>
              </ul>
            </dd>
          </dl>
        </div>

        <dl>
          <dt>주소</dt>
          <dd>
            서울시 동작구 동작대로 89 골든시네마타워 7층<br />
            (4,7호선 이수역 7번 출구 메가박스 건물 7층)
          </dd>
        </dl>

        <dl>
          <dt>문의</dt>
          <dd>02-522-2828</dd>
        </dl>

        <dl>
          <dt>주차장 안내</dt>
          <dd>
            <div class="d-flex flex-column">
              주차 2시간 무료 지원
              <img class="mt-4 border img-fluid" v-lazy="`${publicPath}img/intro/sub_01_carmap_01.png`" />
              <br />
              <div class="row">
                <div class="col-md-6 mt-4">
                  <img class="img-fluid" v-lazy="`${publicPath}img/intro/sub_01_carmap_02.png`" />
                  <span>1. 이수역 7번 출구 LG 베스트샵 끼고 우회전</span>
                </div>
                <div class="col-md-6 mt-4">
                  <img class="img-fluid" v-lazy="`${publicPath}img/intro/sub_01_carmap_03.png`" />
                  <span>2. 골목 진입 후 20미터 우회전</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mt-4">
                  <img class="img-fluid" v-lazy="`${publicPath}img/intro/sub_01_carmap_04.png`" />
                  <span>3. 골든시네마타워에서 오른쪽 방향</span>
                </div>
                <div class="col-md-6 mt-4">
                  <img class="img-fluid" v-lazy="`${publicPath}img/intro/sub_01_carmap_05.png`" />
                  <span>4. 오늘하루치과 주차장 입구</span>
                </div>
              </div>
            </div>
          </dd>
        </dl>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroLocation',
  computed: {
    height() {
      if (this.windowSize.width < 758) {
        return 500;
      }
      if (this.windowSize.width < 480) {
        return 250;
      }
      return 620;
    },
    width() {
      if (this.$refs.map && this.$refs.map.clientWidth) {
        console.log(this.$refs.map.clientWidth);
        return this.$refs.map.clientWidth;
      }

      return this.windowSize.width;
    },
  },
  data() {
    return {
      windowSize: {
        width: 0,
        height: 0,
      },
      info: false,
      marker: null,
      count: 1,
      map: null,
      mapOptions: {
        lat: 37.4846358,
        lng: 126.9816553,
        zoom: 13,
        zoomControlOptions: { position: 'TOP_RIGHT' },
      },
      // eslint-disable-next-line max-len
      mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1206.6388558389762!2d126.98164267034319!3d37.48435742328991!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca1b384aad901%3A0xebef7f6c0426adc8!2z7ISc7Jq47Yq567OE7IucIOuPmeyekeq1rCDsgqzri7kx64-ZIOuPmeyekeuMgOuhnCA4OQ!5e0!3m2!1sko!2skr!4v1574347159118!5m2!1sko!2skr',
    };
  },
  created() {

  },
  destroyed() {
  },
  mounted() {
    const { naver } = window;

    const od = new naver.maps.LatLng(this.mapOptions.lat, this.mapOptions.lng);
    const map = new naver.maps.Map('oneday-location', { center: od, zoom: 13 });
    // eslint-disable-next-line no-unused-vars
    const marker1 = new naver.maps.Marker({
      map,
      position: od,
    });
    // eslint-disable-next-line no-unused-vars
    const marker = new naver.maps.Marker({
      map,
      position: od,
      icon: {
        content: [
          '<div class="od-map-marker">오늘하루치과</div>',
        ].join(''),
        size: new naver.maps.Size(38, 58),
        anchor: new naver.maps.Point(19, 58),
        // pixelOffset: new naver.maps.Point(20, -10),
      },
    });
  },
  methods: {
    onLoad() {
    },
    onWindowLoad() {
    },
    onMarkerClicked() {
      this.info = !this.info;
    },
    onMarkerLoaded(vue) {
      this.marker = vue.marker;
    },
    handleResize() {
      console.log('handleSize');
      this.windowSize.width = window.innerWidth;
      this.windowSize.height = window.innerHeight;
    },
  },
};
</script>

<style lang="scss">
  .od-map-marker {
    font-family: 'Noto Sans KR', serif;
    position: absolute;
    width: 82px;
    top: 58px;
    left: -24px;
    background-color: #fff;
    font-size: 12px;
    padding: 6px 5px;
    font-weight: 700;
    border: solid 2px #055AAF;
    border-radius: 5px;
  }

  .od-map-info {
    padding: 20px;
  }
</style>
